import { NotificationList } from '@/features/notifications/NotificationList';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/notifications')({
  staticData: { nav: 'notifications' },
  validateSearch: z.object({ unread: z.string().optional() }),
  component: NotificationList,
});
